import config from 'config';

const {
  newRelic: { accountID, agentID, licenseKey, trustKey },
} = config;

export function init() {
  const newRelicScript = document.createElement('script');
  newRelicScript.innerHTML = `;window.NREUM||(NREUM={});NREUM.init={distributed_tracing:{enabled:true},privacy:{cookies_enabled:true},ajax:{deny_list:["bam.nr-data.net"]}};
    ;NREUM.loader_config={
      accountID:"${accountID}",
      trustKey:"${trustKey}",
      agentID:"${agentID}",
      licenseKey:"${licenseKey}",
      applicationID:"${agentID}"}
    ;NREUM.info={beacon:"bam.nr-data.net",errorBeacon:"bam.nr-data.net",licenseKey:"${licenseKey}",applicationID:"${agentID}",sa:1};`;

  document.head.appendChild(newRelicScript);
}
